import React, { useEffect, useState } from 'react';
import {Table, Container} from 'react-bootstrap';
import {DeletePackage,DeleteStyle} from '../../../entities/action/action';
import { useSelector } from 'react-redux';

const PackageCategoryAndStyleList = (props)=>{
    const userData = useSelector(state=>state.adminAccount.apiResponse);
    const [dataSet,updateData] = useState([]);
    useEffect(()=>{
        
        (async()=>{
            if(props.type=="Category"){
                const myresponse = await fetch("https://api.zupptravel.com/api/v1/holiday/getHolidayCategories", {
                method: "get",
                headers: {
                    "Content-Type": "application/json",
                }
            });
            const myjson = await myresponse.json();
            console.log("MYJSON",myjson)
            if(myjson?.success){
                updateData(myjson?.holidayCategories || [])
            }
            }else{
                const myresponse = await fetch("https://api.zupptravel.com/api/v1/holiday/getHolidayStyles", {
                method: "get",
                headers: {
                    "Content-Type": "application/json",
                }
            });
            const myjson = await myresponse.json();
            console.log("MYJSON",myjson)
            if(myjson?.success){
                updateData(myjson?.holidayStyles || [])
            }
            }
            
        })()
    
},[props.type])

    const HandleDelete = async(id)=>{
        let response;
        if(props.type=="Category"){
            const newData={
                "emailID": userData.data.key,
                "id": id,
                "sessionKey": userData.sessionId
            }
            response = await DeletePackage(newData);
        }else{
            const newData={
                "emailID": userData.data.key,
                "id": id,
                "sessionKey": userData.sessionId
            }
            response = await DeleteStyle(id);
        }
        if(response.success){
            alert("Successfully Removed");
            window.location.reload();
        }else{
            alert("Not Present or already Removed Please Refresh Your Screen");
        }
    }
    console.log(dataSet)
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Package {props.type}</th>
                        {/* <th>Action</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        dataSet?.length>0?dataSet.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td> {props.type==="Category"?data.categoryName:data.styleName} </td>
                                {/* <td className={classes.CenterRow}>
                                    <Button 
                                        style={{margin:'auto 1%'}} 
                                        variant="danger"
                                        onClick={()=>HandleDelete(data.id)}
                                    >Delete</Button>
                                </td> */}
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
        </Container>
    )
}
export default PackageCategoryAndStyleList;